module.exports = __webpack_public_path__ + "img/unusual-event.ae6d575c.svg";